import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HisBackendService } from 'hisng';
import { GenericValue } from 'hisng';

@Injectable()
export class ErpDocumentService {

    constructor(
        private readonly backendService: HisBackendService,
        private readonly http: HttpClient
    ) { }

    getDocumentCategoryValues(): Observable<GenericValue[]> {
        return this.backendService.getData( 'api/v1/rm/erp/document/value/documentcategory' );
    }

    downloadDocument( fullPath: string ) {
        this.http.get( fullPath, { responseType: 'blob', observe: 'response' } ).subscribe({
            next: ( response: HttpResponse<Blob> ) => {
                if ( response.body ) {
                    const filename = this.getFileNameFromContentDispositionHeader( response.headers );
                    const downloadLink = document.createElement( 'a' );
                    downloadLink.href = URL.createObjectURL( response.body );
                    downloadLink.setAttribute( 'download', filename );
                    document.body.appendChild( downloadLink );
                    downloadLink.click();
                }
            },
            error: ( error: unknown ) => {
                console.log( 'error file download: ' + error );
            }
        });
    }

    private getFileNameFromContentDispositionHeader( httpHeader?: HttpHeaders ): string {
        let contDisp = httpHeader?.get( 'Content-Disposition' );
        if ( contDisp ) {
            const filenameIdent = 'filename="';
            let i = contDisp.indexOf( filenameIdent );

            if ( i < 0 ) {
                return 'Downloadfile';
            }

            contDisp = contDisp.substring( i + filenameIdent.length );
            i = contDisp.indexOf( '"' );

            return contDisp.substring( 0, i );
        } else {
            return 'Downloadfile';
        }
    }
}
